'use client';

import React from 'react';
import clsx from 'clsx';
import styles from './InputAdornment.module.css';
import type { TextFieldSize } from './types';

type InputAdornmentProps = {
  $placement?: 'start' | 'end';
  /** @deprecated No longer used; retained for backward compatibility. */
  $size?: TextFieldSize;
} & React.HTMLAttributes<HTMLDivElement>;

export function InputAdornment({
  $placement,
  $size: _size,
  children,
  className,
  ...other
}: InputAdornmentProps) {
  return (
    <div
      className={clsx(styles.container, className)}
      data-placement={$placement}
      data-vapor-input-adornment
      {...other}
    >
      {children}
    </div>
  );
}
